/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
import { advancedSearch, advancedSecSort } from 'helpers/utils';
import ISearcher from 'ISearcher';
import ISorter from 'ISorter';
import UserResource from './resource';

export class UserSearcher implements ISorter<UserResource, keyof UserResource>, ISearcher<UserResource, keyof UserResource> {
  search = (
    item: UserResource,
    value: any,
    type: keyof UserResource,
  ) => advancedSearch(item, value, type, false);

  sort = (
    a: UserResource,
    b: UserResource,
    primary: keyof UserResource,
    secondary?: keyof UserResource,
  ) => advancedSecSort(a, b, primary, secondary);
}

export default UserSearcher;
